import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime',
  standalone: true,
})
export class FormatTimePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '--';
    }

    try {
      const [hoursStr, minutesStr] = value.split(':');
      let hours = parseInt(hoursStr, 10);

      if (isNaN(hours) || isNaN(parseInt(minutesStr, 10))) {
        return value; // Return original value if parsing fails
      }

      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // The hour '0' should be '12'

      return `${hours}:${minutesStr} ${ampm}`;
    } catch {
      return value; // Return original value in case of any error
    }
  }
}
